import { useMemo } from 'react'
import { getImageSrc } from '@captaincause/lib/getImageSrc'
import { tm } from '../../tm'
import head1 from './head1.webp'
import head2 from './head2.webp'
import head3 from './head3.webp'
import head4 from './head4.webp'
import head5 from './head5.webp'
import head6 from './head6.webp'
import head7 from './head7.webp'
import head8 from './head8.webp'
import head9 from './head9.webp'
import head10 from './head10.webp'
import type { StaticImageData } from 'next/image'

interface HeadIconsProps {
  size?: number
  className?: string
}
const HEADICONS: Array<StaticImageData | string> = [
  head1,
  head2,
  head3,
  head4,
  head5,
  head6,
  head7,
  head8,
  head9,
  head10,
]

const shuffle = (array: any[]) => {
  const arr = [...array]
  for (let i = arr.length - 1; i > 0; i -= 1) {
    const j = Math.floor(Math.random() * (i + 1))
    // eslint-disable-next-line no-param-reassign
    ;[arr[i], arr[j]] = [arr[j], arr[i]]
  }

  return arr
}

const COLORS = [
  'bg-[#FFBCF2]',
  'bg-[#C7EF9D]',
  'bg-[#E0E38E]',
  'bg-[#B5AEFE]',
  'bg-[#DFE1C5]',
]

export function HeadIcons({ size = 5, className = '' }: HeadIconsProps) {
  const shuffleHeads = useMemo(() => shuffle(HEADICONS), [])
  const shuffleColors = useMemo(() => shuffle(COLORS), [])

  if (size === 0) return null
  if (size > 5) {
    throw new Error('Size should be below 6')
  }

  return (
    <div className={tm('flex w-fit', className)}>
      {Array.from({ length: size }, (_, index) => {
        const head = shuffleHeads[index]

        return (
          <div
            key={index}
            className={tm(
              shuffleColors[index],
              '-mr-1 flex h-5 w-5 items-center justify-center rounded-full p-0.5 last:mr-0',
            )}
          >
            <img key={index} src={getImageSrc(head)} alt="Head icon" />
          </div>
        )
      })}
    </div>
  )
}
